import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Serializer, SerializerResponse, Serializers} from "../interfaces/serializer";
import {ChannelType} from "../interfaces/channel-type";
import {Channel} from "../interfaces/channel";
import {Site} from '../interfaces/site';

@Injectable()
export class ChannelsService {

  constructor(
    private readonly _http: HttpClient
  ) {}


  // ##### START Channel types #####
  public getChannelTypes(): Observable<SerializerResponse<Serializers<ChannelType>>> {
    return this._http.get<SerializerResponse<Serializers<ChannelType>>>(`${environment.baseUrl}/api/channel-types`);
  }

  // ###### END Channel types ######

  // ##### START Channels #####
  public getChannels(dataset: Serializer<Site>): Observable<SerializerResponse<Serializers<Channel>>> {
    return this._http.get<SerializerResponse<Serializers<Channel>>>(`${environment.baseUrl}/api/${dataset.id}/data-sources/organic-index`);
  }

  public createOrganicChannel(dataset: Serializer<Site>, channel_infos: Partial<Channel>): Observable<SerializerResponse<Serializer<Channel>>> {
    return this._http.post(`${environment.baseUrl}/api/${dataset.id}/organic-channels`, {channel_infos: channel_infos});
  }

  public updateOrganicChannel(dataset: Serializer<Site>, organic_data_source_id: number, channel_infos: Partial<Channel>): Observable<SerializerResponse<Serializer<Channel>>> {
    return this._http.put(`${environment.baseUrl}/api/${dataset.id}/organic-channels/${organic_data_source_id}`, {channel_infos: channel_infos});
  }

  public deleteOrganicChannel(dataset: Serializer<Site>, organic_data_source_id: number): Observable<any> {
    return this._http.delete(`${environment.baseUrl}/api/${dataset.id}/organic-channels/${organic_data_source_id}`);
  }
  // ###### END Channels ######
}
